export default __webpack_public_path__ + "resources/icons/d241-8c74.webp";